// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
import * as React from 'react';
import { withStyles } from "tss-react/mui";
import { Avatar as MuiAvatar } from '@mui/material';
import { AvatarProps as MuiAvatarProps } from '@mui/material';
import { getColor } from '@shared/utils/common';

interface AvatarProps extends MuiAvatarProps {
  className?: string;
  src?: string;
  fullName: string;
}

const Avatar: React.FC<AvatarProps> = (props: AvatarProps) => {
  const { src, fullName, ...other} = props;
  const classes = withStyles.getClasses(props);

  if (!src && !fullName) {
    return null;
  }

  const name = fullName.split(' ').map((x): string => x[0]).join('').substr(0, 2);
  const nameCodesSum = fullName
    .split('')
    .reduce((acc, char): number => acc + char.charCodeAt(0), 0);

  return (
    <MuiAvatar 
      {...other}
      src={src} 
      alt={fullName}
      style={{ background: getColor(nameCodesSum) }}
      classes={{root: classes.root}}
    >
      {name}
    </MuiAvatar>
  );
  
};

const AvatarStyled = withStyles(
  Avatar, 
  (theme, props) => ({
    "root": {
      width: 40,
      height: 40,
      borderRadius: '50% 50%',
      overflow: 'hidden',
      marginRight: theme.spacing(2),
      fontWeight: 600,
      fontSize: 18,
      textTransform: 'uppercase',
    }
  })
);

export default AvatarStyled;